import { switchFieldConstructor, switchWithSelectFieldConstructor } from "scenes/cohort-filters/filter-configs/fieldContructors";
import { Category } from "scenes/cohort-filters/filter-configs/categories";

const treatmentStatus = [
    { value: "TREATED", label: "global.treated" },
    { value: "UNTREATED", label: "global.untreated" },
];

export const cardioRiskFactorFields = {
    ...switchFieldConstructor({
        category: Category.CARDIO_RISK_FACTORS,
        pathToValue: "anamnesis.smokeStatus",
        label: "anamnesis.cardiovascular.smokeStatus",
    }),
    ...switchFieldConstructor({
        category: Category.CARDIO_RISK_FACTORS,
        pathToValue: "anamnesis.oldSmokeStatus",
        label: "anamnesis.cardiovascular.oldSmokeStatus",
    }),
    ...switchFieldConstructor({
        category: Category.CARDIO_RISK_FACTORS,
        pathToValue: "anamnesis.alcoholDrinkingStatus",
        label: "anamnesis.cardiovascular.alcoholDrinkingStatus",
    }),
    ...switchFieldConstructor({
        category: Category.CARDIO_RISK_FACTORS,
        pathToValue: "anamnesis.familyHeartAttackOrStrokeStatus",
        label: "anamnesis.cardiovascular.familyHeartAttackOrStrokeStatus",
    }),
    ...switchFieldConstructor({
        category: Category.CARDIO_RISK_FACTORS,
        pathToValue: "anamnesis.hasCardiovascularDisease",
        label: "anamnesis.cardiovascular.hasCardiovascularDisease",
    }),
    ...switchWithSelectFieldConstructor({
        category: Category.CARDIO_RISK_FACTORS,
        pathToSwitchQuestion: "anamnesis.hasSufferingFromDiabetes",
        pathToSelectValue: "anamnesis.diabetesState",
        selectOptions: treatmentStatus,
        label: "Diabetes mellitus",
    }),
    ...switchWithSelectFieldConstructor({
        category: Category.CARDIO_RISK_FACTORS,
        pathToSwitchQuestion: "anamnesis.hasSufferingFromHypercholesterolemia",
        pathToSelectValue: "anamnesis.hypercholesterolemiaState",
        selectOptions: treatmentStatus,
        label: "anamnesis.cardiovascular.hypercholesterolemia",
    }),
    ...switchFieldConstructor({
        category: Category.CARDIO_RISK_FACTORS,
        pathToValue: "anamnesis.sportStatus",
        label: "anamnesis.cardiovascular.sportStatus",
    }),
    ...switchFieldConstructor({
        category: Category.CARDIO_RISK_FACTORS,
        pathToValue: "anamnesis.hasHealthyDiet",
        label: "anamnesis.cardiovascular.hasHealthyDiet",
    }),
    ...switchFieldConstructor({
        category: Category.CARDIO_RISK_FACTORS,
        pathToValue: "anamnesis.hasTimePressureAndStress",
        label: "anamnesis.cardiovascular.hasTimePressureAndStress",
    }),
};
